/**
 * i18n Configuration for YAMP Site
 *
 * Uses i18next with react-i18next for React components.
 * Language detection priority:
 * 1. localStorage (yamp-site-language)
 * 2. navigator.language (browser language)
 * 3. 'en' (fallback)
 */

import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import jaCommon from '../locales/ja/common.json'
import jaLanding from '../locales/ja/landing.json'

import enCommon from '../locales/en/common.json'
import enLanding from '../locales/en/landing.json'

// Supported languages
export const SUPPORTED_LANGUAGES = ['en', 'ja'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

// Default language
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en'

// Check if language is supported
export function isValidLanguage(lang: string): lang is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage)
}

// Initialize i18next
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ja: {
        common: jaCommon,
        landing: jaLanding,
      },
      en: {
        common: enCommon,
        landing: enLanding,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    ns: ['common', 'landing'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'yamp-site-language',
      caches: ['localStorage'],
    },
    // Return key if translation is missing (for debugging)
    returnEmptyString: false,
  })

export default i18next
